/**
 * DDS Autocomplete — Județ + Localitate
 * Înlocuiește dropdown-urile cu inputuri text cu sugestii autocomplete.
 * Depinde de: dds-localitati.js (trebuie încărcat ÎNAINTE)
 *
 * Folosire:
 *   DDS_Autocomplete.init({
 *     judetInput: '#judet',
 *     localitateInput: '#localitate',
 *     minChars: 2
 *   });
 */
window.DDS_Autocomplete = (function() {
  'use strict';

  var _judete = [];
  var _data = {};
  var _allFlat = null;

  function _setup() {
    if (!window.DDS_LOCALITATI) return false;
    _data = window.DDS_LOCALITATI;
    _judete = Object.keys(_data).sort(function(a, b) {
      return a.localeCompare(b, 'ro');
    });
    return true;
  }

  /** Creează lista de sugestii (dropdown) sub input */
  function _createDropdown(input) {
    var list = document.createElement('div');
    list.className = 'dds-ac-list';
    list.style.cssText = 'display:none;position:absolute;left:0;right:0;top:100%;' +
      'background:#fffef5;border:2px solid #0b6e5f;border-top:none;border-radius:0 0 12px 12px;' +
      'max-height:260px;overflow-y:auto;z-index:9999;box-shadow:0 6px 20px rgba(0,0,0,0.18);';
    // Wrap input într-un container relative
    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'position:relative;width:100%;';
    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(input);
    wrapper.appendChild(list);
    return list;
  }

  /** Populează lista cu sugestii filtrate */
  function _showSuggestions(list, items, input) {
    list.innerHTML = '';
    if (items.length === 0) {
      list.style.display = 'none';
      return;
    }
    var maxShow = Math.min(items.length, 50);
    for (var i = 0; i < maxShow; i++) {
      var item = document.createElement('div');
      item.className = 'dds-ac-item';
      item.textContent = items[i];
      item.style.cssText = 'padding:13px 16px;cursor:pointer;font-size:17px;' +
        'font-family:Montserrat,sans-serif;font-weight:500;color:#1a1a2e;' +
        'border-bottom:1px solid #e8e8e8;transition:background 0.15s,border-left 0.15s;' +
        'border-left:3px solid transparent;';
      item.addEventListener('mousedown', (function(val) {
        return function(e) {
          e.preventDefault();
          input.value = val;
          list.style.display = 'none';
          input.dispatchEvent(new Event('change', { bubbles: true }));
          // Focus next input
          var next = input.closest('.dds-ac-wrapper') ?
            input.closest('.dds-ac-wrapper').nextElementSibling : null;
          if (next) {
            var nextInput = next.querySelector('input') || next.querySelector('select');
            if (nextInput) nextInput.focus();
          }
        };
      })(items[i]));
      item.addEventListener('mouseenter', function() {
        this.style.backgroundColor = '#e8f5e9';
        this.style.borderLeft = '3px solid #0b6e5f';
      });
      item.addEventListener('mouseleave', function() {
        this.style.backgroundColor = '';
        this.style.borderLeft = '3px solid transparent';
      });
      list.appendChild(item);
    }
    list.style.display = 'block';
  }

  /** Normalizează text — elimină diacritice (ă→a, ș→s, ț→t, î→i, â→a) */
  function _normalize(str) {
    return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  /** Filtrare fuzzy — prioritizează startsWith, apoi includes, ignoră diacritice */
  function _filter(items, query) {
    if (!query || query.length < 1) return [];
    var q = _normalize(query);
    var startsWith = [];
    var contains = [];
    for (var i = 0; i < items.length; i++) {
      var norm = _normalize(items[i]);
      if (norm.indexOf(q) === 0) {
        startsWith.push(items[i]);
      } else if (norm.indexOf(q) > 0) {
        contains.push(items[i]);
      }
    }
    return startsWith.concat(contains);
  }

  /** Obține toate localitățile, opțional filtrate pe județ */
  function _getLocalitati(judetValue) {
    if (judetValue && _data[judetValue]) {
      return _data[judetValue];
    }
    // Dacă nu e completat județul, caută în toate
    var all = [];
    for (var j in _data) {
      if (_data.hasOwnProperty(j)) {
        for (var i = 0; i < _data[j].length; i++) {
          all.push(_data[j][i]);
        }
      }
    }
    // Elimină duplicate și sortează
    return all.filter(function(v, idx, arr) {
      return arr.indexOf(v) === idx;
    }).sort(function(a, b) {
      return a.localeCompare(b, 'ro');
    });
  }

  /** Cache: toate localitățile unice, deduplicate (lazy) */
  function _getAllUniqueLocalities() {
    if (_allFlat) return _allFlat;
    var seen = {};
    _allFlat = [];
    for (var j in _data) {
      if (_data.hasOwnProperty(j)) {
        for (var i = 0; i < _data[j].length; i++) {
          var name = _data[j][i];
          if (!seen[name]) {
            seen[name] = true;
            _allFlat.push(name);
          }
        }
      }
    }
    _allFlat.sort(function(a, b) { return a.localeCompare(b, 'ro'); });
    return _allFlat;
  }

  /** Returnează județele care conțin o localitate cu acest nume */
  function _getCountiesForLocality(localityName) {
    var norm = _normalize(localityName);
    var counties = [];
    for (var j in _data) {
      if (_data.hasOwnProperty(j)) {
        for (var i = 0; i < _data[j].length; i++) {
          if (_normalize(_data[j][i]) === norm) {
            counties.push(j);
            break;
          }
        }
      }
    }
    return counties;
  }

  /** Inițializare pe un set de inputuri */
  function init(opts) {
    if (!_setup()) {
      console.warn('DDS_Autocomplete: DDS_LOCALITATI nu e încărcat.');
      return;
    }

    var judetEl = typeof opts.judetInput === 'string' ?
      document.querySelector(opts.judetInput) : opts.judetInput;
    var localEl = typeof opts.localitateInput === 'string' ?
      document.querySelector(opts.localitateInput) : opts.localitateInput;
    var minChars = opts.minChars || 2;

    if (!judetEl || !localEl) {
      console.warn('DDS_Autocomplete: Elementele nu au fost găsite.');
      return;
    }

    // Transformă select în input dacă e cazul
    judetEl = _ensureInput(judetEl, 'Scrie județul...');
    localEl = _ensureInput(localEl, 'Scrie localitatea...');

    var judetList = _createDropdown(judetEl);
    var localList = _createDropdown(localEl);

    // Județ blocat până se completează localitatea
    function _lockJudet() {
      judetEl.disabled = true;
      judetEl.style.opacity = '0.6';
      judetEl.style.cursor = 'not-allowed';
      judetEl.placeholder = 'Completează localitatea mai întâi';
    }
    function _unlockJudet() {
      judetEl.disabled = false;
      judetEl.style.opacity = '1';
      judetEl.style.cursor = '';
      judetEl.placeholder = 'Scrie județul...';
    }
    // Blocat inițial dacă nu e deja completat
    if (!localEl.value.trim()) _lockJudet();

    // === JUDEȚ autocomplete (restricționat la județul localității selectate) ===
    judetEl.addEventListener('input', function() {
      var val = this.value;
      if (val.length < minChars) {
        judetList.style.display = 'none';
        return;
      }
      var locVal = localEl.value.trim();
      var matching = locVal ? _getCountiesForLocality(locVal) : [];
      var available = matching.length > 0 ? matching : _judete;
      var filtered = _filter(available, val);
      _showSuggestions(judetList, filtered, judetEl);
    });

    judetEl.addEventListener('focus', function() {
      var locVal = localEl.value.trim();
      var matching = locVal ? _getCountiesForLocality(locVal) : [];
      var available = matching.length > 0 ? matching : _judete;
      // Dacă e text scris, filtrează; altfel arată toate opțiunile
      var val = this.value.trim();
      var toShow = val.length >= minChars ? _filter(available, val) : available;
      _showSuggestions(judetList, toShow, judetEl);
    });

    judetEl.addEventListener('blur', function() {
      setTimeout(function() {
        judetList.style.display = 'none';
        var typed = judetEl.value.trim();
        if (!typed) return;
        // 1. Verifică dacă e un județ real
        var match = null;
        for (var i = 0; i < _judete.length; i++) {
          if (_normalize(_judete[i]) === _normalize(typed)) {
            match = _judete[i];
            break;
          }
        }
        if (!match) {
          judetEl.value = '';
          return;
        }
        // 2. Dacă e localitate completată, verifică dacă județul e valid PENTRU ea
        var locVal = localEl.value.trim();
        if (locVal) {
          var validCounties = _getCountiesForLocality(locVal);
          var isValidForLoc = validCounties.some(function(c) {
            return _normalize(c) === _normalize(match);
          });
          if (!isValidForLoc) {
            // Județul nu conține această localitate — pune județul corect automat
            if (validCounties.length === 1) {
              judetEl.value = validCounties[0];
            } else {
              judetEl.value = '';
            }
            return;
          }
        }
        // Auto-corectare diacritice
        if (judetEl.value !== match) judetEl.value = match;
      }, 200);
    });

    // === LOCALITATE autocomplete (caută în TOATE județele) ===
    localEl.addEventListener('input', function() {
      var val = this.value;
      if (val.length < minChars) {
        localList.style.display = 'none';
        return;
      }
      var filtered = _filter(_getAllUniqueLocalities(), val);
      _showSuggestions(localList, filtered, localEl);
    });

    localEl.addEventListener('focus', function() {
      if (this.value.length >= minChars) {
        var filtered = _filter(_getAllUniqueLocalities(), this.value);
        _showSuggestions(localList, filtered, localEl);
      }
    });

    localEl.addEventListener('blur', function() {
      setTimeout(function() {
        localList.style.display = 'none';
        // Forțează selecție validă — dacă textul nu e o localitate reală, golește
        var typed = localEl.value.trim();
        if (!typed) return;
        var allLocs = _getAllUniqueLocalities();
        var match = null;
        var normTyped = _normalize(typed);
        for (var i = 0; i < allLocs.length; i++) {
          if (_normalize(allLocs[i]) === normTyped) {
            match = allLocs[i];
            break;
          }
        }
        if (match) {
          // Auto-corectare: pune forma corectă cu diacritice
          if (localEl.value !== match) {
            localEl.value = match;
            localEl.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          // Nu e localitate validă — golește + reblochează județul
          localEl.value = '';
          judetEl.value = '';
          _lockJudet();
        }
      }, 200);
    });

    // Când se schimbă localitatea, actualizează județul automat
    localEl.addEventListener('change', function() {
      var locVal = localEl.value.trim();
      if (!locVal) {
        judetEl.value = '';
        _lockJudet();
        return;
      }
      _unlockJudet();
      var counties = _getCountiesForLocality(locVal);
      if (counties.length === 0) return;
      var currentJudet = judetEl.value.trim();
      // Verifică dacă județul curent e valid pentru noua localitate
      var currentIsValid = currentJudet && counties.some(function(c) {
        return _normalize(c) === _normalize(currentJudet);
      });
      if (!currentIsValid) {
        // Județul curent nu corespunde — auto-fill dacă e unic, altfel golește
        judetEl.value = counties.length === 1 ? counties[0] : '';
        judetEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Când se schimbă județul, validează-l în raport cu localitatea existentă
    var _prevJudet = judetEl.value || '';
    judetEl.addEventListener('change', function() {
      var newJudet = judetEl.value.trim();
      if (newJudet === _prevJudet) return;

      if (localEl.value) {
        var locVal = localEl.value.trim();
        var validCounties = _getCountiesForLocality(locVal);
        if (validCounties.length > 0) {
          var isValidForLoc = validCounties.some(function(c) {
            return _normalize(c) === _normalize(newJudet);
          });
          if (!isValidForLoc) {
            // Județul nu corespunde localității — revert la județul valid unic sau clear
            judetEl.value = validCounties.length === 1 ? validCounties[0] : '';
            newJudet = judetEl.value;
          }
        }
      }
      _prevJudet = newJudet;
    });
  }

  /** Transformă un <select> în <input type="text"> păstrând id, name, class */
  function _ensureInput(el, placeholder) {
    if (el.tagName === 'SELECT') {
      var input = document.createElement('input');
      input.type = 'text';
      input.id = el.id;
      input.name = el.name;
      input.className = el.className;
      input.required = el.required;
      input.placeholder = placeholder || '';
      input.setAttribute('autocomplete', 'off');
      el.parentNode.replaceChild(input, el);
      return input;
    }
    el.setAttribute('autocomplete', 'off');
    if (!el.placeholder) el.placeholder = placeholder || '';
    return el;
  }

  // ═══════════════════════════════════════════════════════════════
  // VALIDARE NUME — reutilizabil pe toate formularele
  // ═══════════════════════════════════════════════════════════════

  // Caractere permise în nume: litere (inclusiv diacritice RO), spații, cratimă, apostrof, punct
  var _nameRegex = /^[a-zA-ZÀ-ÖØ-öø-ÿĂăÂâÎîȘșȚțŞşŢţ\s\-'.]+$/;

  /**
   * Validează un nume complet. Returnează null dacă e valid, sau string cu eroarea.
   * Reguli:
   *  - Min 3 caractere
   *  - Fără cifre
   *  - Doar litere, spații, cratimă, apostrof, punct
   *  - Cel puțin 2 cuvinte (nume + prenume)
   *  - Fiecare cuvânt minim 2 caractere
   */
  function validateName(name) {
    if (!name || name.trim().length < 3) return 'Numele trebuie să aibă cel puțin 3 caractere.';
    var trimmed = name.trim();
    if (/\d/.test(trimmed)) return 'Numele nu poate conține cifre.';
    if (!_nameRegex.test(trimmed)) return 'Numele conține caractere nepermise.';
    var words = trimmed.split(/\s+/);
    if (words.length < 2) return 'Completează numele ȘI prenumele.';
    for (var i = 0; i < words.length; i++) {
      if (words[i].replace(/['.]/g, '').length < 2) return 'Fiecare parte a numelui trebuie să aibă cel puțin 2 caractere.';
    }
    return null; // valid
  }

  /**
   * Auto-capitalize: "ion popescu" → "Ion Popescu", "ana-maria" → "Ana-Maria"
   * Elimină automat punctele sau semnele care blochează CRM-ul
   */
  function formatName(name) {
    var cleaned = (name || '').replace(/[\.]/g, ' ').replace(/\s+/g, ' ').trim();
    return cleaned.replace(/(^|[\s\-])([a-zA-ZÀ-ÖØ-öø-ÿĂăÂâÎîȘșȚțŞşŢţ])/g, function(match, sep, letter) {
      return sep + letter.toUpperCase();
    });
  }

  /**
   * Atașează pe un input: strip cifre/caractere interzise la fiecare tastare + auto-capitalize la blur.
   * @param {string|HTMLElement} selector - CSS selector sau element DOM
   */
  function attachNameGuard(selector) {
    var el = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!el) return;

    // Strip cifre și caractere interzise la fiecare tastare
    el.addEventListener('input', function() {
      var pos = el.selectionStart;
      var before = el.value;
      // Elimină cifre, puncte și caractere interzise (păstrăm litere, diacritice, spații, cratimă, apostrof)
      var cleaned = before.replace(/[0-9.]/g, '').replace(/[^a-zA-ZÀ-ÖØ-öø-ÿĂăÂâÎîȘșȚțŞşŢţ\s\-']/g, '');
      if (cleaned !== before) {
        el.value = cleaned;
        el.setSelectionRange(Math.min(pos, cleaned.length), Math.min(pos, cleaned.length));
      }
    });

    // Auto-capitalize la blur
    el.addEventListener('blur', function() {
      if (el.value.trim()) {
        el.value = formatName(el.value);
      }
    });
  }

  // ═══════════════════════════════════════════════════════════════
  // VALIDARE TELEFON — reutilizabil pe toate formularele
  // ═══════════════════════════════════════════════════════════════

  /**
   * Curăță un nr de telefon: elimină spații, cratime, paranteze.
   * Normalizează prefixe internaționale (+40, 0040) la format 0X.
   */
  function cleanPhone(raw) {
    var clean = (raw || '').replace(/[\s\-\.\(\)]/g, '');
    // Elimină prefix internațional
    if (clean.indexOf('+40') === 0) clean = '0' + clean.slice(3);
    if (clean.indexOf('0040') === 0) clean = '0' + clean.slice(4);
    if (/^40\d{9}$/.test(clean)) clean = '0' + clean.slice(2);
    return clean;
  }

  /**
   * Validează un nr de telefon RO. Returnează null dacă e valid, sau string cu eroarea.
   * Reguli: doar cifre, 10 caractere, începe cu 07
   */
  function validatePhone(raw) {
    var clean = cleanPhone(raw);
    if (!clean) return 'INTRODUCEȚI NUMĂRUL DE TELEFON';
    // Verifică caractere interzise (orice non-cifră)
    if (/[^0-9]/.test(clean)) return 'NUMĂRUL NU POATE CONȚINE LITERE SAU CARACTERE SPECIALE';
    if (clean.length < 10) return 'NUMĂRUL TREBUIE SĂ AIBĂ 10 CIFRE (EX: 07XX XXX XXX)';
    if (clean.length > 10) return 'NUMĂRUL ARE PREA MULTE CIFRE — VERIFICAȚI';
    if (clean.indexOf('07') !== 0) return 'NUMĂRUL TREBUIE SĂ ÎNCEAPĂ CU 07';
    return null; // valid
  }

  /**
   * Atașează pe un input de telefon:
   *  - Strip non-cifre la fiecare tastare (permite doar +, spațiu pt UX temporar)
   *  - Previne paste de caractere speciale
   */
  function attachPhoneGuard(selector) {
    var el = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!el) return;

    el.addEventListener('input', function() {
      var pos = el.selectionStart;
      var before = el.value;
      // Permitem doar cifre, +, spații, cratime (UX-friendly la typing)
      var cleaned = before.replace(/[^0-9+\s\-]/g, '');
      if (cleaned !== before) {
        el.value = cleaned;
        el.setSelectionRange(Math.min(pos, cleaned.length), Math.min(pos, cleaned.length));
      }
      // Reset border on valid typing
      if (el.style.borderColor === 'rgb(229, 57, 53)') {
        el.style.borderColor = '';
      }
    });
  }

  // ═══════════════════════════════════════════════════════════════
  // MODAL VALIDARE — centrat pe ecran, buton OK, fără auto-dismiss
  // Audiență 50+ ani, nu observă tooltip-uri care dispar rapid
  // ═══════════════════════════════════════════════════════════════

  function showValidationAlert(text, onClose) {
    var existing = document.getElementById('dds-validation-overlay');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.id = 'dds-validation-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box;animation:dds-modal-fade-in 0.2s ease;';

    var modal = document.createElement('div');
    modal.style.cssText = 'background:#fff;border-radius:16px;padding:28px 24px 20px;max-width:360px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,0.25);text-align:center;animation:dds-modal-scale-in 0.25s ease;';

    var icon = document.createElement('div');
    icon.style.cssText = 'width:52px;height:52px;border-radius:50%;background:#fff3e0;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;border:2px solid #ff9800;';
    icon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#e65100" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>';

    var msg = document.createElement('p');
    msg.textContent = text;
    msg.style.cssText = 'font-family:Inter,Poppins,sans-serif;font-size:17px;font-weight:600;color:#1a1a2e;line-height:1.4;margin:0 0 20px 0;word-break:break-word;';

    var okBtn = document.createElement('button');
    okBtn.type = 'button';
    okBtn.textContent = 'OK';
    okBtn.style.cssText = 'background:#0b6e5f;color:#fff;border:none;border-radius:12px;padding:14px 48px;font-family:Inter,Poppins,sans-serif;font-size:18px;font-weight:700;cursor:pointer;min-height:50px;min-width:140px;box-shadow:0 4px 12px rgba(11,110,95,0.3);transition:background 0.15s,transform 0.1s;-webkit-tap-highlight-color:transparent;';

    okBtn.addEventListener('mouseenter', function() { okBtn.style.background = '#095a4e'; });
    okBtn.addEventListener('mouseleave', function() { okBtn.style.background = '#0b6e5f'; });
    okBtn.addEventListener('touchstart', function() { okBtn.style.transform = 'scale(0.96)'; }, { passive: true });
    okBtn.addEventListener('touchend', function() { okBtn.style.transform = ''; }, { passive: true });

    function closeModal() {
      overlay.style.animation = 'dds-modal-fade-out 0.15s ease forwards';
      setTimeout(function() {
        if (overlay.parentNode) overlay.remove();
        if (typeof onClose === 'function') onClose();
      }, 150);
    }

    okBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });

    modal.appendChild(icon);
    modal.appendChild(msg);
    modal.appendChild(okBtn);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    if (!document.getElementById('dds-modal-animations')) {
      var style = document.createElement('style');
      style.id = 'dds-modal-animations';
      style.textContent = '@keyframes dds-modal-fade-in{from{opacity:0}to{opacity:1}}@keyframes dds-modal-fade-out{from{opacity:1}to{opacity:0}}@keyframes dds-modal-scale-in{from{opacity:0;transform:scale(0.9)}to{opacity:1;transform:scale(1)}}';
      document.head.appendChild(style);
    }

    setTimeout(function() { okBtn.focus(); }, 100);
  }

  /**
   * Afișează un modal cu 2 opțiuni pentru avertismente (ex: lipsă număr stradă)
   * @param {string} text - textul de afișat
   * @param {function} onCorrect - apelat când se alege "Corectează Adresa"
   * @param {function} onConfirm - apelat când se alege "Trimite Comanda"
   */
  function showWarningConfirm(text, onCorrect, onConfirm) {
    var existing = document.getElementById('dds-validation-overlay');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.id = 'dds-validation-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box;animation:dds-modal-fade-in 0.2s ease;';

    var modal = document.createElement('div');
    modal.style.cssText = 'background:#fff;border-radius:16px;padding:28px 24px 24px;max-width:380px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,0.25);text-align:center;animation:dds-modal-scale-in 0.25s ease;';

    var icon = document.createElement('div');
    icon.style.cssText = 'width:52px;height:52px;border-radius:50%;background:#fff3e0;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;border:2px solid #ff9800;';
    icon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#e65100" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>';

    var msg = document.createElement('p');
    msg.textContent = text;
    msg.style.cssText = 'font-family:Inter,Poppins,sans-serif;font-size:17px;font-weight:600;color:#1a1a2e;line-height:1.4;margin:0 0 24px 0;word-break:break-word;';

    var btnContainer = document.createElement('div');
    btnContainer.style.cssText = 'display:flex;flex-direction:column;gap:12px;';

    // Butonul Trimite Comanda (Solid verde)
    var confirmBtn = document.createElement('button');
    confirmBtn.type = 'button';
    confirmBtn.textContent = 'Trimite Comanda';
    confirmBtn.style.cssText = 'background:#0b6e5f;color:#fff;border:none;border-radius:12px;padding:14px 20px;font-family:Inter,Poppins,sans-serif;font-size:17px;font-weight:700;cursor:pointer;min-height:50px;box-shadow:0 4px 12px rgba(11,110,95,0.3);transition:background 0.15s,transform 0.1s;-webkit-tap-highlight-color:transparent;';

    confirmBtn.addEventListener('mouseenter', function() { confirmBtn.style.background = '#095a4e'; });
    confirmBtn.addEventListener('mouseleave', function() { confirmBtn.style.background = '#0b6e5f'; });
    confirmBtn.addEventListener('touchstart', function() { confirmBtn.style.transform = 'scale(0.97)'; }, { passive: true });
    confirmBtn.addEventListener('touchend', function() { confirmBtn.style.transform = ''; }, { passive: true });

    // Butonul Corectează Adresa (Outlined)
    var correctBtn = document.createElement('button');
    correctBtn.type = 'button';
    correctBtn.textContent = 'Corectează Adresa';
    correctBtn.style.cssText = 'background:#fff;color:#0b6e5f;border:2px solid #0b6e5f;border-radius:12px;padding:14px 20px;font-family:Inter,Poppins,sans-serif;font-size:17px;font-weight:700;cursor:pointer;min-height:50px;transition:background 0.15s,color 0.15s,transform 0.1s;-webkit-tap-highlight-color:transparent;';

    correctBtn.addEventListener('mouseenter', function() { correctBtn.style.background = '#e8f5e9'; });
    correctBtn.addEventListener('mouseleave', function() { correctBtn.style.background = '#fff'; });
    correctBtn.addEventListener('touchstart', function() { correctBtn.style.transform = 'scale(0.97)'; }, { passive: true });
    correctBtn.addEventListener('touchend', function() { correctBtn.style.transform = ''; }, { passive: true });

    function closeAndExecute(cb) {
      overlay.style.animation = 'dds-modal-fade-out 0.15s ease forwards';
      setTimeout(function() {
        if (overlay.parentNode) overlay.remove();
        if (typeof cb === 'function') cb();
      }, 150);
    }

    correctBtn.addEventListener('click', function() {
      closeAndExecute(onCorrect);
    });

    confirmBtn.addEventListener('click', function() {
      closeAndExecute(onConfirm);
    });

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeAndExecute(onCorrect);
      }
    });

    btnContainer.appendChild(confirmBtn);
    btnContainer.appendChild(correctBtn);
    modal.appendChild(icon);
    modal.appendChild(msg);
    modal.appendChild(btnContainer);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    if (!document.getElementById('dds-modal-animations')) {
      var style = document.createElement('style');
      style.id = 'dds-modal-animations';
      style.textContent = '@keyframes dds-modal-fade-in{from{opacity:0}to{opacity:1}}@keyframes dds-modal-fade-out{from{opacity:1}to{opacity:0}}@keyframes dds-modal-scale-in{from{opacity:0;transform:scale(0.9)}to{opacity:1;transform:scale(1)}}';
      document.head.appendChild(style);
    }

    setTimeout(function() { confirmBtn.focus(); }, 100);
  }

  // ═══════════════════════════════════════════════════════════════
  // VALIDARE ADRESĂ — reutilizabil pe toate formularele
  // ═══════════════════════════════════════════════════════════════

  /**
   * Validează adresa completă. Returnează array de erori.
   * Fiecare eroare: { message: string, severity: 'error' | 'warning', field: string }
   * Array gol = totul e valid.
   *
   * Reguli implementate:
   *  R1: Strada trebuie să conțină un număr (WARNING)
   *  R2: Strada nu poate fi identică cu localitatea (BLOCARE)
   *  R4: Județul trebuie să existe în baza DPD (BLOCARE)
   *  R5: Localitatea trebuie să existe în județul selectat (BLOCARE)
   *  R8: Detectare adresă duplicată (WARNING)
   */
  function validateAddress(opts) {
    if (!_setup()) return [];
    var errors = [];
    var street = (opts.street || '').trim();
    var locality = (opts.locality || '').trim();
    var county = (opts.county || '').trim();

    // R2: Strada nu poate fi identică cu localitatea
    if (street && locality && _normalize(street) === _normalize(locality)) {
      errors.push({
        message: 'Strada nu poate fi aceeași cu localitatea. Scrieți adresa completă (stradă și număr).',
        severity: 'error',
        field: 'address'
      });
    }

    // R4: Județul trebuie să existe în baza DPD
    if (county) {
      var judetValid = _judete.some(function(j) {
        return _normalize(j) === _normalize(county);
      });
      if (!judetValid) {
        errors.push({
          message: 'Județul „' + county + '" nu a fost găsit. Selectați din lista de sugestii.',
          severity: 'error',
          field: 'judet'
        });
      }
    }

    // R5: Localitatea trebuie să existe în județul selectat
    if (locality && county) {
      var realCounty = _findRealCountyName(county);
      if (realCounty) {
        var locExists = _data[realCounty].some(function(loc) {
          return _normalize(loc) === _normalize(locality);
        });
        if (!locExists) {
          // Încearcă fuzzy — poate e doar o problemă de diacritice
          var fuzzyMatch = _fuzzyFindLocality(locality, realCounty);
          if (fuzzyMatch) {
            // Găsit fuzzy — nu blocăm, dar atenționăm (optional)
          } else {
            errors.push({
              message: 'Localitatea „' + locality + '" nu a fost găsită în județul ' + realCounty + '. Verificați datele.',
              severity: 'error',
              field: 'localitate'
            });
          }
        }
      }
    } else if (locality && !county) {
      // Localitate fără județ — verificăm dacă există undeva
      var anywhere = _getCountiesForLocality(locality);
      if (anywhere.length === 0) {
        errors.push({
          message: 'Localitatea „' + locality + '" nu a fost găsită. Verificați ortografia.',
          severity: 'error',
          field: 'localitate'
        });
      }
    }

    // R1: Strada trebuie să conțină un număr (WARNING)
    if (street && !/\d/.test(street)) {
      errors.push({
        message: 'Strada nu conține un număr. Curierul ar putea avea dificultăți la livrare.',
        severity: 'warning',
        field: 'address'
      });
    }

    // R8: Detectare adresă duplicată (WARNING)
    if (street && locality) {
      var streetNorm = _normalize(street);
      var localNorm = _normalize(locality);
      // Verifică dacă strada conține localitatea repetată
      var parts = street.split(/[,;]+/).map(function(p) { return _normalize(p.trim()); }).filter(Boolean);
      var uniqueParts = [];
      var hasDuplicates = false;
      for (var i = 0; i < parts.length; i++) {
        if (uniqueParts.indexOf(parts[i]) !== -1) {
          hasDuplicates = true;
          break;
        }
        uniqueParts.push(parts[i]);
      }
      if (hasDuplicates) {
        errors.push({
          message: 'Adresa pare să conțină informații duplicate. Verificați.',
          severity: 'warning',
          field: 'address'
        });
      }
    }

    return errors;
  }

  /** Găsește numele real al județului (cu diacritice corecte) din baza DPD */
  function _findRealCountyName(input) {
    var norm = _normalize(input);
    for (var i = 0; i < _judete.length; i++) {
      if (_normalize(_judete[i]) === norm) return _judete[i];
    }
    return null;
  }

  /** Fuzzy search: caută o localitate în județul dat, tolerant la diacritice */
  function _fuzzyFindLocality(locality, county) {
    if (!_data[county]) return null;
    var norm = _normalize(locality);
    for (var i = 0; i < _data[county].length; i++) {
      if (_normalize(_data[county][i]) === norm) return _data[county][i];
    }
    return null;
  }

  return {
    init: init,
    validateName: validateName,
    formatName: formatName,
    attachNameGuard: attachNameGuard,
    validatePhone: validatePhone,
    cleanPhone: cleanPhone,
    attachPhoneGuard: attachPhoneGuard,
    showValidationAlert: showValidationAlert,
    showWarningConfirm: showWarningConfirm,
    validateAddress: validateAddress
  };
})();
